import * as React from 'react';

interface CharacterCountProps {
  value: string;
  max: number;
}

export const CharacterCount = ({ value, max }: CharacterCountProps) => {
  return (
    <div
      className="character-count"
      style={{
        color: value.length > max ? 'red' : 'inherit'
      }}
    >
      {value.length} / {max}
    </div>
  );
};
